module.exports = __webpack_public_path__ + "img/right_mask.3666e3a4.svg";